
// $('.tag-subcollection a').each(function() {
//     $(this).on('click', function(e) {
//         console.log("tag-subcollection click");
//         e.preventDefault();
//         e.stopPropagation();
//         var selectedValue = $(this).text().trim();
//         console.log("selectedValue___:", selectedValue);
     
//         var checkbox = $('input[name="filter.p.m.custom.top_filters"][value="' + selectedValue + '"]');
//         console.log("checkbox___:", checkbox);
       
//         if (checkbox.length) {
//             console.log('Checkbox found for value: ' + selectedValue);
//             // const label = document.querySelector('label[for="Filter-Top Filters-2"]');
//             // if(label){
//             //   label.click();
//             // }
//              checkbox.trigger('click');
//         } else {
//             console.log('Checkbox not found for value: ' + selectedValue);
//         }
        
//         console.log(selectedValue);
//     });
// });

    $(document).on('click', '.tag-subcollection a',function(e) {
        console.log("tag-subcollection click");
        e.preventDefault();
        e.stopPropagation();
        var selectedValue = $(this).text().trim();
        console.log("selectedValue___:", selectedValue);
     
        var checkbox = $('input[name="filter.p.m.custom.top_filters"][value="' + selectedValue + '"]');
        console.log("checkbox___:", checkbox);
       
        if (checkbox.length) {
            console.log('Checkbox found for value: ' + selectedValue);
            // const label = document.querySelector('label[for="Filter-Top Filters-2"]');
            // if(label){
            //   label.click();
            // }
             checkbox.trigger('click');
        } else {
            console.log('Checkbox not found for value: ' + selectedValue);
        }
        
        console.log(selectedValue);
    });

  

 // $('#selling-plan-dropdown').change(function() {
 //      var selectedPlanId = $(this).val();
 //      var selectedPlanName = $(this).find('option:selected').data('name');
 //      console.log(selectedPlanId, selectedPlanName); 
      
 //      $('#selling-plan-hidden').val(selectedPlanId);
 //      $('#selling-plan-name-hidden').val(selectedPlanName);
 //      $('#selling-plan-label').text(selectedPlanName);
 //    });
 $('#selling-plan-dropdown').change(function() {
    var selectedPlanId = $(this).val();
    var selectedPlanName = $(this).find('option:selected').data('name');

    
      $('#selling-plan-hidden').val(selectedPlanId);
      $('#selling-plan-name-hidden').val(selectedPlanName);
      $('#selling-plan-label').text(selectedPlanName);
    
  });

